"use client"

import { Fragment } from 'react'
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { Col, Layout, Row, Skeleton } from "antd"
import { usePathname } from 'next/navigation'

const BasicLayoutHeaderSkeleton = () => {
  const isDesktop = useIsDesktop()
  const pathname = usePathname()

  let name = 'Store'

  if (pathname.startsWith('/product/')) {
    name = 'Product'
  } else if (pathname.startsWith('/products/')) {
    name = 'Store'
  } else if (pathname.startsWith('/category/')) {
    name = 'Category'
  } else if (pathname.startsWith('/cart')) {
    name = 'Cart'
  } else if (pathname.startsWith('/checkout')) {
    name = 'Checkout'
  } else if (pathname.startsWith('/payment')) {
    name = 'Payment'
  }

  return (
    <Layout.Header
      className='basic_layout--header'
    >
      <Row align="middle" justify="center" style={{ height: '6.4rem' }}>
        <Col className="page__section">
          <Row wrap={false} align="middle" justify='space-between'>
            <Col>
              <Row wrap={false} gutter={5} align="middle">
                <Col>
                  <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3.2rem', width: '3.2rem' } }} />
                </Col>
                <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: 35, width: 35 } }} />
                {isDesktop && (
                  <>
                    {[
                      {},
                      {},
                      {},
                    ].map((_, idx) => {
                      if (!isDesktop) {
                        return <Fragment key={idx} />
                      }
                      return (
                        <Col key={idx}>
                          <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: 35, width: 35 } }} />
                        </Col>
                      )
                    })}
                  </>
                )}
              </Row>
            </Col>
            <Col flex={1}>
              <Row justify='center'>
                <Col>
                  <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3.2rem', width: '15rem' } }} />
                </Col>
              </Row>
            </Col>
            <Col>
              <Skeleton active paragraph={false} styles={{ title: { margin: 0, height: '3.2rem', width: '6.4rem' } }} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout.Header>
  )
}

export default BasicLayoutHeaderSkeleton